module.exports = __webpack_public_path__ + "static/img/7.66d0314.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/05/7.png
// module id = Os/L
// module chunks = 2